import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Section = styled(FlexColumn)<{ withSeparator?: boolean }>`
    width: 100%;
    padding: 24px 0;

    &.noTopPadding {
        padding-top: 0;
    }
    &.noBottomPadding {
        padding-bottom: 0;
    }

    ${({ withSeparator }) =>
        withSeparator &&
        css`
            border-bottom: 1px solid ${carbon[100]};
            margin-bottom: 24px;
        `};
`;
